var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "DIV",
        { staticClass: "overflow-auto" },
        [
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "2",
                contentColsMd: "8",
                name: "name",
                label: _vm._f("pgettext")("Name", "Template"),
                labelAlign: _vm.labelAlign
              }
            },
            [
              _c("ItpFormInput", {
                attrs: { name: "name", required: "" },
                model: {
                  value: _vm.item.name,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "name", $$v)
                  },
                  expression: "item.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "2",
                contentColsMd: "8",
                name: "object_type",
                label: _vm._f("pgettext")("Object Type", "Template"),
                labelAlign: _vm.labelAlign
              }
            },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "object_type",
                  options: _vm.objectTypes,
                  required: ""
                },
                model: {
                  value: _vm.item.object_type,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "object_type", $$v)
                  },
                  expression: "item.object_type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "2",
                contentColsMd: "8",
                name: "template_type",
                label: _vm._f("pgettext")("Template Type", "Template"),
                labelAlign: _vm.labelAlign
              }
            },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "template_type",
                  options: _vm.templateTypes,
                  required: ""
                },
                model: {
                  value: _vm.item.template_type,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "template_type", $$v)
                  },
                  expression: "item.template_type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { style: _vm.b_4892266742011185_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: {
              text: _vm._f("pgettext")("Subject", "Template"),
              strong: ""
            }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "html", options: _vm.b_5970972589163186_options },
            model: {
              value: _vm.item.subject,
              callback: function($$v) {
                _vm.$set(_vm.item, "subject", $$v)
              },
              expression: "item.subject"
            }
          }),
          _vm._v(" "),
          _c("hr", { style: _vm.b_785371160721131_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: {
              text: _vm._f("pgettext")("Header", "Template"),
              strong: ""
            }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "html", options: _vm.b_253425746720918_options },
            model: {
              value: _vm.item.header,
              callback: function($$v) {
                _vm.$set(_vm.item, "header", $$v)
              },
              expression: "item.header"
            }
          }),
          _vm._v(" "),
          _c("hr", { style: _vm.b_2748386552601189_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: {
              text: _vm._f("pgettext")("Content", "Template"),
              strong: ""
            }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "html", options: _vm.b_1712041292317581_options },
            model: {
              value: _vm.item.content,
              callback: function($$v) {
                _vm.$set(_vm.item, "content", $$v)
              },
              expression: "item.content"
            }
          }),
          _vm._v(" "),
          _c("hr", { style: _vm.b_539880003873724_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: {
              text: _vm._f("pgettext")("Footer", "Template"),
              strong: ""
            }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "html", options: _vm.b_6324823719113312_options },
            model: {
              value: _vm.item.footer,
              callback: function($$v) {
                _vm.$set(_vm.item, "footer", $$v)
              },
              expression: "item.footer"
            }
          }),
          _vm._v(" "),
          _c("hr", { style: _vm.b_219110658038496_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: { text: _vm._f("pgettext")("CSS", "Template"), strong: "" }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "css", options: _vm.b_3034545286442485_options },
            model: {
              value: _vm.item.css,
              callback: function($$v) {
                _vm.$set(_vm.item, "css", $$v)
              },
              expression: "item.css"
            }
          }),
          _vm._v(" "),
          _c("hr", { style: _vm.b_4556014673857397_style }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: {
              text: _vm._f("pgettext")("Sample data", "Template"),
              strong: ""
            }
          }),
          _vm._v(" "),
          _c("CodeMirror", {
            staticClass: "border",
            attrs: { mode: "json", options: _vm.b_7786722825496231_options },
            model: {
              value: _vm.context.sampleData,
              callback: function($$v) {
                _vm.$set(_vm.context, "sampleData", $$v)
              },
              expression: "context.sampleData"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }